export default __webpack_public_path__ + "static/media/logo_beta_web.dc821bfe.png";